module.exports = require('./src/forum');
